import WebGalleryCard from './WebGalleryCard';

export default WebGalleryCard;
